import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { TextButton } from '../TextButton';
import { smsMessages } from '../../utils/sms';
const fade = {
  hidden: {
    opacity: 0,
    y: 14
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function Hero() {
  return <section className="bg-canvas" data-id="element-95" data-mp="eqeunmkm324z">
      <div className="mx-auto max-w-shell px-5 pb-16 pt-14 sm:px-8 lg:pb-24 lg:pt-20" data-id="element-96" data-mp="epdmpqyw6vrh">
        <div className="grid items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16" data-id="element-97" data-mp="apl7wwiwntdo">
          <motion.div initial="hidden" animate="show" transition={{
          staggerChildren: 0.06
        }} data-id="element-98" data-mp="5p79m673vxsu">
            <motion.p variants={fade} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1]
          }} className="text-xs uppercase tracking-[0.18em] text-aqua-600" data-id="element-99" data-mp="qm7204dt218">
              Powered by Fusion 44X &middot; Zero chlorine &middot; Zero
              chemicals
            </motion.p>

            <motion.h1 variants={fade} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1]
          }} className="mt-5 font-display text-[38px] font-semibold leading-[1.02] tracking-tightest text-ink-950 sm:text-[54px] lg:text-[64px]" data-id="element-100" data-mp="1mwm1bxucto5f">
              Hydrosprings uses Fusion 44X &mdash; the world&rsquo;s first
              self-maintaining, 100% chemical-free pool system.
            </motion.h1>

            <motion.p variants={fade} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1]
          }} className="mt-7 max-w-xl text-[17px] leading-relaxed text-ink-700" data-id="element-101" data-mp="25nc4zorr1ezc">
              As an authorized Fusion 44X dealer, we install and service the
              system that turns ordinary pool and spa water into a
              self-cleaning, self-balancing body of water &mdash; so pure it
              meets EPA drinking-water standards, validated independently by the
              Water Institute in Phoenix, Arizona.
            </motion.p>

            <motion.div variants={fade} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1]
          }} className="mt-9 flex flex-wrap items-center gap-3" data-id="element-102" data-mp="337v8trc6pfhs">
              <TextButton message={smsMessages.quote} size="lg" data-id="element-103" data-mp="2u65loxpc52pt">
                Text us
              </TextButton>
              <Link to="/shop" className="inline-flex items-center justify-center rounded-full border border-ink-950/15 bg-white px-7 py-3.5 text-[15px] font-medium text-ink-950 transition-colors duration-150 ease-smooth hover:border-ink-950/35 hover:bg-canvas" data-id="element-104" data-mp="2paq5w07rowqr">
                Shop systems
              </Link>
            </motion.div>

            <motion.p variants={fade} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1]
          }} className="mt-5 text-[13px] text-ink-600" data-id="element-105" data-mp="26jz1ld2mzwj8">
              A specialist replies by text, usually within minutes.
            </motion.p>
          </motion.div>

          <motion.figure initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.05
        }} className="overflow-hidden rounded-2xl bg-aqua-100 shadow-lift" data-id="element-106" data-mp="c40blw69h8j0">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/c607324b-60f0-4347-9148-bbc4537d8d8b.jpg" alt="A modern pool with completely clear water at golden hour" className="aspect-[4/3] w-full object-cover lg:aspect-[5/6]" data-id="element-107" data-mp="q0vx4o3p8sfy" />
          </motion.figure>
        </div>

        <dl className="mt-16 grid gap-8 border-t border-ink-950/10 pt-10 sm:grid-cols-3 lg:mt-20" data-id="element-108" data-mp="72krc6bwr61o">
          {[{
          term: '7.2\u20137.6 pH',
          desc: 'Held naturally, without dosing'
        }, {
          term: 'Self-balancing',
          desc: 'No weekly testing or dosing'
        }, {
          term: 'EPA standard',
          desc: 'Drinking-water grade clarity'
        }].map(stat => <div key={stat.term} data-id="element-109" data-mp="2rkycvqww387w">
              <dt className="font-display text-2xl font-semibold tracking-tight text-ink-950" data-id="element-110" data-mp="2moq0umdznv4y">
                {stat.term}
              </dt>
              <dd className="mt-1.5 text-sm text-ink-600" data-id="element-111" data-mp="31ef7uy8ritd5">{stat.desc}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}